(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__klFaqBound) return;
    window.__klFaqBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-kl-faq-toggle]') : null;
      if (!btn) return;
      var item = btn.closest('.kl-faq__item');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!item || !panel) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);
      if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-how-wide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic = /[?&]static(=|&|$)/.test(location.search);
    function boot() {
      var cards = document.querySelectorAll('[data-klhw]:not([data-klhw-on])');
      if (!cards.length || reduce || isStatic || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var el = en.target;
          if (en.isIntersecting && en.intersectionRatio > 0.3) {
            if (!el.classList.contains('is-play')) { el.getBoundingClientRect(); el.classList.add('is-play'); }
            el.classList.add('is-live');
          } else if (!en.isIntersecting) {
            el.classList.remove('is-live');
          }
        });
      }, { threshold: [0, 0.3] });
      cards.forEach(function (el) {
        el.setAttribute('data-klhw-on', '');
        if (el.getBoundingClientRect().top > window.innerHeight * 0.8) el.classList.add('is-armed');
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-mechanism"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic = /[?&]static(=|&|$)/.test(location.search);
    function run(el) {
      if (el._klmBusy || (el._klmRuns || 0) >= 1) return;
      el._klmBusy = true;
      el._klmRuns = (el._klmRuns || 0) + 1;
      el.classList.remove('is-p2', 'is-done');
      el.classList.add('is-run', 'is-p1');
      setTimeout(function () {
        el.classList.remove('is-p1');
        el.classList.add('is-p2');
        setTimeout(function () {
          el.classList.add('is-done');
          el._klmBusy = false;
        }, 3200);
      }, 1150);
    }
    function boot() {
      var arts = document.querySelectorAll('[data-klm]:not([data-klm-on])');
      if (!arts.length || reduce || isStatic || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.55) run(en.target);
        });
      }, { threshold: [0, 0.55] });
      arts.forEach(function (el) { el.setAttribute('data-klm-on', ''); io.observe(el); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-progress"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic = /[?&]static(=|&|$)/.test(location.search);

    function load(key) {
      try { var v = JSON.parse(localStorage.getItem(key) || 'null'); return Array.isArray(v) && v.length === 84 ? v : null; } catch (e) { return null; }
    }
    function save(key, arr) { try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {} }

    function setup(wrap) {
      if (wrap.hasAttribute('data-klp-on')) return;
      wrap.setAttribute('data-klp-on', '');
      var cells = Array.prototype.slice.call(wrap.querySelectorAll('.kl-prog__cell'));
      var pages = wrap.querySelector('[data-klp-pages]');
      var pgBtns = wrap.querySelectorAll('[data-klp-page]');
      var key = wrap.getAttribute('data-klp-key');
      var touched = false;
      var mode = 'example';
      var dry = '', wet = '';
      var legend = wrap.querySelectorAll('.kl-prog__legend li');
      if (legend.length === 2) { dry = legend[0].textContent.trim(); wet = legend[1].textContent.trim(); }

      /* phone pager: the track slides one page at a time (no scroll, so nothing can stop half way) */
      var track = wrap.querySelector('[data-klp-track]');
      var page = 0;
      function goPage(n) {
        page = n;
        wrap.classList.toggle('is-page-2', n === 1);
        pgBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === n); });
      }
      pgBtns.forEach(function (b) {
        b.addEventListener('click', function () { touched = true; goPage(+b.getAttribute('data-klp-page')); });
      });
      if (pages) {
        var x0 = null, y0 = 0;
        pages.addEventListener('touchstart', function (e) { touched = true; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        pages.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goPage(dx < 0 ? 1 : 0);
        }, { passive: true });
      }
      function isPhone() { return window.matchMedia('(max-width: 1023px)').matches; }

      /* runs of 14 or more dry nights */
      function markRuns() {
        var n = 0, start = 0;
        cells.forEach(function (c) { c.classList.remove('is-run'); });
        for (var i = 0; i <= cells.length; i++) {
          var f = i < cells.length && cells[i].getAttribute('data-s') === 'f';
          if (f) { if (!n) start = i; n++; }
          else { if (n >= 14) for (var k = start; k < i; k++) cells[k].classList.add('is-run'); n = 0; }
        }
        wrap.classList.toggle('has-run', !!wrap.querySelector('.kl-prog__cell.is-run'));
      }
      function label(c) {
        var s = c.getAttribute('data-s');
        c.setAttribute('aria-label', c.getAttribute('data-name') + (s === 'f' ? ': ' + dry : s === 'w' ? ': ' + wet : ''));
      }

      /* modes */
      var modeBtns = wrap.querySelectorAll('[data-klp-mode]');
      var noteEx = wrap.querySelector('[data-klp-note-example]');
      var noteMine = wrap.querySelector('[data-klp-note-mine]');
      function setMode(m) {
        mode = m;
        wrap.classList.remove('is-armed', 'is-play');
        wrap.classList.toggle('is-mine', m === 'mine');
        modeBtns.forEach(function (b) {
          var on = b.getAttribute('data-klp-mode') === m;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var mine = m === 'mine' ? (load(key) || new Array(84).fill('e')) : null;
        cells.forEach(function (c, i) {
          c.setAttribute('data-s', mine ? mine[i] : c.getAttribute('data-ex'));
          c.tabIndex = mine ? 0 : -1;
          label(c);
        });
        if (noteEx) noteEx.hidden = m === 'mine';
        if (noteMine) noteMine.hidden = m !== 'mine';
        markRuns();
        if (m === 'mine') goPage(0);
      }
      modeBtns.forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-klp-mode')); }); });
      cells.forEach(function (c) {
        c.addEventListener('click', function () {
          if (mode !== 'mine') return;
          var s = c.getAttribute('data-s');
          var next = s === 'e' ? 'f' : s === 'f' ? 'w' : 'e';
          c.setAttribute('data-s', next);
          label(c);
          c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop');
          save(key, cells.map(function (x) { return x.getAttribute('data-s'); }));
          markRuns();
        });
      });
      var clear = wrap.querySelector('[data-klp-clear]');
      if (clear) clear.addEventListener('click', function () {
        try { localStorage.removeItem(key); } catch (e) {}
        setMode('mine');
      });

      /* the stick-on run */
      if (reduce || isStatic || !('IntersectionObserver' in window)) return;
      var r = wrap.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.7) return;
      wrap.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio < 0.35) return;
          io.disconnect();
          if (mode !== 'example') return;
          wrap.getBoundingClientRect();
          wrap.classList.add('is-play');
          if (isPhone()) setTimeout(function () { if (!touched && mode === 'example') goPage(1); }, 42 * 55 + 250);
        });
      }, { threshold: [0, 0.35] });
      io.observe(wrap);
    }

    function marks() {
      var lists = document.querySelectorAll('[data-klp-marks]:not([data-klp-on])');
      if (!lists.length || reduce || isStatic || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-play'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -25% 0px' });
      lists.forEach(function (l) {
        l.setAttribute('data-klp-on', '');
        if (l.getBoundingClientRect().top > window.innerHeight * 0.75) { l.classList.add('is-armed'); io.observe(l); }
      });
    }
    function boot() { document.querySelectorAll('[data-klp]').forEach(setup); marks(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__klReviewsBound) return;
    window.__klReviewsBound = true;
    function fit(root) {
      (root || document).querySelectorAll('[data-kl-rv-text].is-clamped').forEach(function (t) {
        var btn = t.parentNode.querySelector('[data-kl-rv-readmore]');
        if (!btn || t.classList.contains('is-open')) return;
        if (t.scrollHeight > t.clientHeight + 2) btn.removeAttribute('hidden'); else btn.setAttribute('hidden', '');
      });
    }
    document.addEventListener('click', function (e) {
      var rm = e.target.closest ? e.target.closest('[data-kl-rv-readmore]') : null;
      if (rm) {
        var t = rm.parentNode.querySelector('[data-kl-rv-text]');
        var open = !t.classList.contains('is-open');
        t.classList.toggle('is-open', open);
        rm.setAttribute('aria-expanded', open ? 'true' : 'false');
        rm.textContent = open ? rm.getAttribute('data-label-less') : rm.getAttribute('data-label-more');
        return;
      }
      var sm = e.target.closest ? e.target.closest('[data-kl-rv-showmore]') : null;
      if (sm) {
        var sec = sm.closest('[data-kl-section="reviews"]');
        var step = parseInt(sm.getAttribute('data-kl-rv-step'), 10) || 0;
        var left = Array.prototype.filter.call(sec.querySelectorAll('[data-kl-rv-extra]'), function (it) { return it.hasAttribute('hidden'); });
        var take = step > 0 ? left.slice(0, step) : left;
        take.forEach(function (it) { it.removeAttribute('hidden'); });
        if (take.length >= left.length) sm.setAttribute('hidden', '');
        fit(sec);
      }
    });
    function init() { fit(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    window.addEventListener('load', function () { fit(); });
    window.addEventListener('resize', function () { fit(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic = /[?&]static(=|&|$)/.test(location.search) || /static/.test(location.hash);
    function count(el, delay) {
      var to = parseInt(el.getAttribute('data-kl-count'), 10) || 0;
      var dur = 1100;
      setTimeout(function () {
        var t0 = null;
        function step(t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * e) + '%';
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, delay);
    }
    function init() {
      if (reduce || isStatic || !('IntersectionObserver' in window)) return;
      var sums = document.querySelectorAll('[data-kl-stats-sum]:not([data-kl-armed])');
      if (!sums.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var sum = en.target;
          io.unobserve(sum);
          sum.classList.add('is-play');
          sum.querySelectorAll('[data-kl-count]').forEach(function (el) {
            var row = el.closest('.kl-stats__row');
            var i = row ? parseInt(row.style.getPropertyValue('--i'), 10) || 0 : 0;
            count(el, i * 180 + 150);
          });
        });
      }, { rootMargin: '0px 0px -22% 0px' });
      sums.forEach(function (sum) {
        sum.setAttribute('data-kl-armed', '');
        var r = sum.getBoundingClientRect();
        // Already on screen when the script runs: leave it full, nothing to animate in.
        if (r.top < window.innerHeight * 0.78) return;
        sum.classList.add('is-armed');
        sum.querySelectorAll('[data-kl-count]').forEach(function (el) { el.textContent = '0%'; });
        io.observe(sum);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__klStickyBound) return;
    window.__klStickyBound = true;
    function apply(detail) {
      if (!detail) return;
      var bars = document.querySelectorAll('[data-kl-sticky]');
      for (var j = 0; j < bars.length; j++) {
        var bar = bars[j];
        if (typeof detail.available !== 'undefined') {
          var btns = bar.querySelectorAll('[data-kl-atc]');
          for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            b.disabled = !detail.available;
            var txt = detail.available ? b.getAttribute('data-kl-label-buy') : b.getAttribute('data-kl-label-sold-out');
            if (txt) b.textContent = txt;
          }
        }
        var save = bar.querySelector('[data-kl-sticky-save]');
        if (save && typeof detail.compareAt === 'number' && typeof detail.price === 'number') {
          // the badge matches the total shown: pack plus ticked add-ons
          var pct = typeof detail.totalSavingsPercent === 'number' ? detail.totalSavingsPercent
            : (detail.compareAt > 0 ? Math.floor(((detail.compareAt - detail.price) * 100) / detail.compareAt) : 0);
          var tpl = save.getAttribute('data-kl-sticky-save-template') || '';
          save.textContent = tpl.replace('[percent]', String(pct));
          if (pct > 0) save.removeAttribute('hidden'); else save.setAttribute('hidden', '');
        }
        var forEl = bar.querySelector('[data-kl-sticky-for]');
        if (forEl) {
          var ftpl = forEl.getAttribute('data-kl-sticky-for-template') || '';
          if (ftpl && detail.quantity > 1) { forEl.textContent = ftpl.replace('[qty]', String(detail.quantity)); forEl.removeAttribute('hidden'); }
          else { forEl.textContent = ''; forEl.setAttribute('hidden', ''); }
        }
        var pack = bar.querySelector('[data-kl-sticky-pack]');
        if (pack) {
          var ptpl = pack.getAttribute('data-kl-sticky-pack-template') || '';
          if (ptpl && detail.quantity > 1) { pack.textContent = ptpl.replace('[qty]', String(detail.quantity)); pack.removeAttribute('hidden'); }
          else { pack.textContent = ''; pack.setAttribute('hidden', ''); }
        }
      }
    }
    document.addEventListener('kl:pack-change', function (e) { apply(e.detail); });
    function init() { if (window.KL && window.KL.state) apply(window.KL.state); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-trust-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic = /[?&]static(=|&|$)/.test(location.search) || /static/.test(location.hash);
    function init() {
      if (reduce || isStatic || !('IntersectionObserver' in window)) return;
      var lists = document.querySelectorAll('[data-kl-why-list]:not([data-kl-armed])');
      if (!lists.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-play');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -18% 0px' });
      lists.forEach(function (list) {
        list.setAttribute('data-kl-armed', '');
        var r = list.getBoundingClientRect();
        // Already on screen when the script runs: leave it at rest, nothing to animate in.
        if (r.top < window.innerHeight * 0.82) return;
        list.classList.add('is-armed');
        io.observe(list);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
